import React, { useState } from "react";

const TDEECalculator = ({ tezina, visina, pol, godine }) => {
  const [weight, setWeight] = useState(tezina);
  const [height, setHeight] = useState(visina);
  const [age, setAge] = useState(godine);
  const [gender, setGender] = useState(pol);
  const [activityLevel, setActivityLevel] = useState("1.2");
  const [tdee, setTdee] = useState(null);

  const handleCalculate = () => {
    if (!weight) {
      alert("Molimo unesite težinu (kg) za obračun TDEE");
      return;
    }
    if (!height) {
      alert("Molimo unesite visinu (cm) za obračun TDEE");
      return;
    }
    if (!age) {
      alert("Molimo unesite godine za obračun TDEE");
      return;
    }

    let bmrValue;
    if (gender === "muski") {
      bmrValue = 88.36 + 13.4 * weight + 4.8 * height - 5.7 * age;
    } else {
      bmrValue = 447.6 + 9.2 * weight + 3.1 * height - 4.3 * age;
    }

    // TDEE formula
    const tdeeValue = bmrValue * parseFloat(activityLevel);
    setTdee(tdeeValue);
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md border border-gray-500">
      <h1 className="text-3xl font-bold text-gray-800 text-center">
        TDEE Kalkulator
      </h1>
      <h4 className="text-gray-800 text-center mb-6">(Dnevni unos kalorija)</h4>
      <div className="flex space-x-4 mb-4">
        <div className="flex flex-col flex-grow">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Težina (kg)
          </label>
          <input
            type="number"
            placeholder="Težina (kg)"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            className="border border-gray-300 rounded-lg p-3 w-full"
          />
        </div>
        <div className="flex flex-col flex-grow">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Visina (cm)
          </label>
          <input
            type="number"
            placeholder="Visina (cm)"
            value={height}
            onChange={(e) => setHeight(e.target.value)}
            className="border border-gray-300 rounded-lg p-3 w-full"
          />
        </div>
      </div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Godine
      </label>
      <input
        type="number"
        placeholder="Godine"
        value={age}
        onChange={(e) => setAge(e.target.value)}
        className="border border-gray-300 rounded-lg p-3 w-full mb-4"
      />
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Pol
        </label>
        <select
          value={gender}
          onChange={(e) => setGender(e.target.value)}
          className="border border-gray-300 rounded-lg p-3 w-full"
        >
          <option value="zenski">Žensko</option>
          <option value="muski">Muško</option>
        </select>
      </div>
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Vaš nivo aktivnosti (personalizovanije).
        </label>
        <select
          value={activityLevel}
          onChange={(e) => setActivityLevel(e.target.value)}
          className="border border-gray-300 rounded-lg p-3 w-full"
        >
          <option value="1.2">Sedentaran (malo ili nimalo vežbanja)</option>
          <option value="1.375">
            Lagano aktivan (lakše vežbanje/sport 1-3 dana u nedelji)
          </option>
          <option value="1.55">
            Umereno aktivan (umereno vežbanje/sport 3-5 dana u nedelji)
          </option>
          <option value="1.725">
            Veoma aktivan (intenzivno vežbanje/sport 6-7 dana u nedelji)
          </option>
          <option value="1.9">
            Ekstremno aktivan (veoma intenzivno vežbanje, fizički posao)
          </option>
        </select>
      </div>
      <button
        onClick={handleCalculate}
        className="w-full bg-blue-600 text-white rounded-lg py-3 hover:bg-blue-700 transition duration-300"
      >
        Izračunaj TDEE
      </button>

      {tdee !== null && (
        <div className="mt-6 text-center">
          <h2 className="text-2xl font-semibold text-gray-800">
            Tvoj TDEE: {tdee.toFixed(2)} kalorija/dan
          </h2>
        </div>
      )}
    </div>
  );
};

export default TDEECalculator;
